export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिंदी' },
  { code: 'te', label: 'తెలుగు' },
  { code: 'ta', label: 'தமிழ்' },
  { code: 'mr', label: 'मराठी' },
];

export const translations = {
  en: {
    appTitle: 'Udyogverse',
    turn: 'Turn',
    chooseAction: 'Action chuno (Choose your action)',
    executed: 'executed!',
    nextTurn: 'Agla Turn',
    turnComplete: (turn, tile, stageName) =>
      `Turn ${turn} complete! Tile ${tile} | ${stageName} stage`,
    dashboard: 'Dashboard',
    funds: 'Funds',
    customers: 'Customers',
    reputation: 'Reputation',
    burnRate: 'Burn Rate',
    ownership: 'Ownership',
    stage: 'Stage',
    customerTarget: 'Customer Target',
    turnLog: 'Turn Log',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    bugMeter: 'Bug Meter',
    stable: 'Stable',
    risky: 'Risky',
    fragile: 'Fragile',
    snakeChance: (pct) => `Snake chance: ${pct}%`,
    snakeLegend: 'Saanp (Snake)',
    ladderLegend: 'Seedhi (Ladder)',
    youLegend: 'You',
    snakeTooltip: 'Saanp!',
    ladderTooltip: 'Seedhi!',
    goTo: 'Go to',
    climbTo: 'Climb to',
    tileWord: 'Tile',
    marketing: 'Marketing',
    product: 'Product',
    team: 'Team',
    bugfix: 'Bug Fix',
    fundraise: 'Fundraise',
    save: 'Save',
    customersLabel: 'customers',
    equityLabel: 'equity',
    repPlus: 'Rep +',
    repMinus: 'Rep -',
    burnPlus: 'Burn +',
    burnMinus: 'Burn -',
    bugLabel: 'Bug',
    rolling: 'Rolling...',
    rollDice: 'Pasa Phenk! (Roll Dice)',
    eventSnakeTitle: 'Saanp! (Snake)',
    eventLadderTitle: 'Seedhi! (Ladder)',
    eventBugTitle: 'Bug Alert!',
    eventStageUpTitle: 'Stage Up!',
    eventWinTitle: 'Safal Udyam!',
    eventGameOverTitle: 'Game Over',
    eventStruggleTitle: 'Struggle Mode',
    snakeFell: (from, to) => `Tile ${from} se ${to} tak gire!`,
    snakeEffectText: '(-5 customers, -Rs.3,000)',
    ladderClimbed: (from, to) => `Tile ${from} se ${to} tak chadhe!`,
    ladderEffectText: '(+10 customers)',
    stageComplete: 'complete! Welcome to',
    rewardWord: 'reward',
    currencyPrefix: 'Rs.',
    winText: 'Congratulations! Aap Safal Udyami ban gaye!',
    winSubText: 'You built a successful business!',
    struggleText: 'Funds khatam ho rahe hain! Sambhal ke chalo.',
    struggleSubText: 'Recovery is still possible!',
    loseText: 'Business band karna pada. Par haar mat mano!',
    loseSubText: 'Every failure is a lesson.',
    acknowledgeWin: 'Dekho Result',
    acknowledgeNext: 'Aage Badho',
    gameWonTitle: 'Safal Udyam!',
    gameLostTitle: 'Haar Nahi Maanenge!',
    gameWonSubtitle: 'Congratulations! You built a successful business!',
    gameLostSubtitle: 'The journey ends here, but the learning continues.',
    stageReachedLabel: 'Stage',
    turnsLabel: 'Turns',
    leaderboard: 'Leaderboard',
    playAgain: 'Phir se khelo! (Play Again)',
    emptyLog: 'Abhi koi turn nahi hua... Shuruaat karo!',
    startSubtitle: 'Learn business by playing',
    startSubtitleLocal: 'खेल खेल में बिज़नेस सीखो',
    enterNameLabel: 'Apna naam batao (Your Name)',
    namePlaceholder: 'Enter your name...',
    chooseStartupLabel: 'Apna idea chuno (Choose your startup)',
    customIdeaName: 'Custom Idea',
    customIdeaLocal: 'अपना आइडिया',
    customPlaceholder: 'Describe your startup idea...',
    customSummaryPrefix: 'Custom startup',
    startButton: 'Shuruaat Karo',
    startFooter: 'Roll the dice. Build your empire. Become a Safal Udyami!',
    langToggle: 'Language',
    signupTab: 'Sign Up',
    loginTab: 'Login',
    emailLabel: 'Email Address',
    passwordLabel: 'Password',
    passwordHint: 'Min 6 characters',
    confirmPasswordLabel: 'Confirm Password',
    passwordMismatch: "Passwords don't match",
    createAccountBtn: 'Create Account',
    loginBtn: 'Login',
    creatingAccount: 'Creating Account...',
    loggingIn: 'Logging in...',
    emailPlaceholder: 'Enter your email...',
    passwordPlaceholder: 'Create a password...',
    confirmPlaceholder: 'Re-enter password...',
    loginPasswordPlaceholder: 'Enter your password...',
  },

  hi: {
    appTitle: 'उद्योगवर्स',
    turn: 'पारी',
    chooseAction: 'अपनी कार्रवाई चुनें',
    executed: 'हो गया!',
    nextTurn: 'अगली पारी',
    turnComplete: (turn, tile, stageName) =>
      `पारी ${turn} पूरी! खाना ${tile} | ${stageName} चरण`,
    dashboard: 'डैशबोर्ड',
    funds: 'धन',
    customers: 'ग्राहक',
    reputation: 'प्रतिष्ठा',
    burnRate: 'खर्च दर',
    ownership: 'स्वामित्व',
    stage: 'चरण',
    customerTarget: 'ग्राहक लक्ष्य',
    turnLog: 'पारी इतिहास',
    low: 'कम',
    medium: 'मध्यम',
    high: 'अधिक',
    bugMeter: 'समस्या मीटर',
    stable: 'स्थिर',
    risky: 'जोखिम भरा',
    fragile: 'नाज़ुक',
    snakeChance: (pct) => `सांप का मौका: ${pct}%`,
    snakeLegend: 'सांप',
    ladderLegend: 'सीढ़ी',
    youLegend: 'आप',
    snakeTooltip: 'सांप!',
    ladderTooltip: 'सीढ़ी!',
    goTo: 'जाओ',
    climbTo: 'चढ़ो',
    tileWord: 'खाना',
    marketing: 'मार्केटिंग',
    product: 'उत्पाद',
    team: 'टीम',
    bugfix: 'समस्या समाधान',
    fundraise: 'फंड जुटाओ',
    save: 'बचाओ',
    customersLabel: 'ग्राहक',
    equityLabel: 'हिस्सेदारी',
    repPlus: 'प्रतिष्ठा +',
    repMinus: 'प्रतिष्ठा -',
    burnPlus: 'खर्च +',
    burnMinus: 'खर्च -',
    bugLabel: 'समस्या',
    rolling: 'फेंक रहे हैं...',
    rollDice: 'पासा फेंको!',
    eventSnakeTitle: 'सांप!',
    eventLadderTitle: 'सीढ़ी!',
    eventBugTitle: 'समस्या चेतावनी!',
    eventStageUpTitle: 'चरण आगे!',
    eventWinTitle: 'सफल उद्यम!',
    eventGameOverTitle: 'खेल खत्म',
    eventStruggleTitle: 'संघर्ष काल',
    snakeFell: (from, to) => `खाना ${from} से ${to} पर गिरे!`,
    snakeEffectText: '(-5 ग्राहक, -रु.3,000)',
    ladderClimbed: (from, to) => `खाना ${from} से ${to} पर चढ़े!`,
    ladderEffectText: '(+10 ग्राहक)',
    stageComplete: 'पूर्ण! स्वागत है',
    rewardWord: 'इनाम',
    currencyPrefix: 'रु.',
    winText: 'बधाई हो! आप सफल उद्यमी बन गए!',
    winSubText: 'आपने एक सफल व्यवसाय बनाया!',
    struggleText: 'पैसे खत्म हो रहे हैं! सावधानी से चलो।',
    struggleSubText: 'अभी वापसी संभव है!',
    loseText: 'व्यवसाय बंद करना पड़ा। पर हार मत मानो!',
    loseSubText: 'हर असफलता एक सबक है।',
    acknowledgeWin: 'नतीजा देखो',
    acknowledgeNext: 'आगे बढ़ो',
    gameWonTitle: 'सफल उद्यम!',
    gameLostTitle: 'हार नहीं मानेंगे!',
    gameWonSubtitle: 'बधाई हो! आपने सफल व्यवसाय बनाया!',
    gameLostSubtitle: 'सफर यहाँ रुकता है, पर सीखना जारी है।',
    stageReachedLabel: 'चरण',
    turnsLabel: 'पारियाँ',
    leaderboard: 'लीडरबोर्ड',
    playAgain: 'फिर से खेलो!',
    emptyLog: 'अभी कोई पारी नहीं हुई... शुरुआत करो!',
    startSubtitle: 'खेल कर व्यवसाय सीखो',
    startSubtitleLocal: 'खेल खेल में बिज़नेस सीखो',
    enterNameLabel: 'अपना नाम बताओ',
    namePlaceholder: 'अपना नाम लिखो...',
    chooseStartupLabel: 'अपना आइडिया चुनो',
    customIdeaName: 'अपना आइडिया',
    customIdeaLocal: 'अपना आइडिया',
    customPlaceholder: 'अपने स्टार्टअप का आइडिया बताओ...',
    customSummaryPrefix: 'कस्टम स्टार्टअप',
    startButton: 'शुरुआत करो',
    startFooter: 'पासा फेंको। अपना साम्राज्य बनाओ। सफल उद्यमी बनो!',
    langToggle: 'भाषा',
    signupTab: 'Sign Up',
    loginTab: 'Login',
    emailLabel: 'ईमेल पता',
    passwordLabel: 'पासवर्ड',
    passwordHint: 'कम से कम 6 अक्षर',
    confirmPasswordLabel: 'पासवर्ड दोबारा',
    passwordMismatch: 'पासवर्ड मेल नहीं खाते',
    createAccountBtn: 'खाता बनाएं',
    loginBtn: 'लॉगिन करें',
    creatingAccount: 'खाता बना रहे हैं...',
    loggingIn: 'लॉगिन हो रहा है...',
    emailPlaceholder: 'ईमेल डालो...',
    passwordPlaceholder: 'पासवर्ड बनाओ...',
    confirmPlaceholder: 'दोबारा डालो...',
    loginPasswordPlaceholder: 'पासवर्ड डालो...',
  },

  te: {
    appTitle: 'ఉద్యోగ్‌వర్స్',
    turn: 'పాళీ',
    chooseAction: 'మీ చర్య ఎంచుకోండి',
    executed: 'పూర్తయింది!',
    nextTurn: 'తదుపరి పాళీ',
    turnComplete: (turn, tile, stageName) =>
      `పాళీ ${turn} పూర్తైంది! టైల్ ${tile} | ${stageName} దశ`,
    dashboard: 'డాష్‌బోర్డ్',
    funds: 'నిధులు',
    customers: 'కస్టమర్లు',
    reputation: 'పేరుప్రతిష్ఠ',
    burnRate: 'వ్యయ రేటు',
    ownership: 'యాజమాన్యం',
    stage: 'దశ',
    customerTarget: 'కస్టమర్ లక్ష్యం',
    turnLog: 'పాళీ చరిత్ర',
    low: 'తక్కువ',
    medium: 'మధ్యమం',
    high: 'అధికం',
    bugMeter: 'బగ్ మీటర్',
    stable: 'స్థిరంగా',
    risky: 'ప్రమాదకరం',
    fragile: 'అస్థిరంగా',
    snakeChance: (pct) => `పాము అవకాశం: ${pct}%`,
    snakeLegend: 'పాము (Snake)',
    ladderLegend: 'నిచ్చెన (Ladder)',
    youLegend: 'మీరు',
    snakeTooltip: 'పాము!',
    ladderTooltip: 'నిచ్చెన!',
    goTo: 'వెళ్ళు',
    climbTo: 'ఎక్కు',
    tileWord: 'టైల్',
    marketing: 'మార్కెటింగ్',
    product: 'ఉత్పత్తి',
    team: 'జట్టు',
    bugfix: 'బగ్ పరిష్కారం',
    fundraise: 'నిధుల సేకరణ',
    save: 'ఆదా',
    customersLabel: 'కస్టమర్లు',
    equityLabel: 'వాటా',
    repPlus: 'పేరు +',
    repMinus: 'పేరు -',
    burnPlus: 'వ్యయం +',
    burnMinus: 'వ్యయం -',
    bugLabel: 'బగ్',
    rolling: 'వేస్తున్నాం...',
    rollDice: 'పాచికలు వేయండి!',
    eventSnakeTitle: 'పాము! (Snake)',
    eventLadderTitle: 'నిచ్చెన! (Ladder)',
    eventBugTitle: 'బగ్ హెచ్చరిక!',
    eventStageUpTitle: 'దశ పెరిగింది!',
    eventWinTitle: 'విజయవంతమైన వ్యాపారం!',
    eventGameOverTitle: 'గేమ్ ఓవర్',
    eventStruggleTitle: 'కష్టకాలం',
    snakeFell: (from, to) => `టైల్ ${from} నుంచి ${to} కు పడ్డారు!`,
    snakeEffectText: '(-5 కస్టమర్లు, -రూ.3,000)',
    ladderClimbed: (from, to) => `టైల్ ${from} నుంచి ${to} కు ఎక్కారు!`,
    ladderEffectText: '(+10 కస్టమర్లు)',
    stageComplete: 'పూర్తి! స్వాగతం',
    rewardWord: 'బహుమానం',
    currencyPrefix: 'రూ.',
    winText: 'అభినందనలు! మీరు విజయవంతమైన వ్యాపారవేత్త అయ్యారు!',
    winSubText: 'మీరు విజయవంతమైన వ్యాపారాన్ని నిర్మించారు!',
    struggleText: 'నిధులు తగ్గిపోతున్నాయి! జాగ్రత్తగా ముందుకు వెళ్ళండి.',
    struggleSubText: 'కోలుకోవడం ఇంకా సాధ్యం!',
    loseText: 'వ్యాపారం మూసివేయాల్సి వచ్చింది. కానీ వదిలిపెట్టకండి!',
    loseSubText: 'ప్రతి వైఫల్యం ఒక పాఠం.',
    acknowledgeWin: 'ఫలితం చూడండి',
    acknowledgeNext: 'ముందుకు వెళ్ళు',
    gameWonTitle: 'విజయవంతమైన వ్యాపారం!',
    gameLostTitle: 'వదిలిపెట్టం!',
    gameWonSubtitle: 'అభినందనలు! మీరు విజయవంతమైన వ్యాపారాన్ని నిర్మించారు!',
    gameLostSubtitle: 'ప్రయాణం ఇక్కడ ముగుస్తుంది, కానీ నేర్చుకోవడం కొనసాగుతుంది.',
    stageReachedLabel: 'దశ',
    turnsLabel: 'పాళీలు',
    leaderboard: 'లీడర్‌బోర్డ్',
    playAgain: 'మళ్ళీ ఆడండి!',
    emptyLog: 'ఇంకా ఏ పాళీ జరగలేదు... ప్రారంభించండి!',
    startSubtitle: 'ఆడుతూ వ్యాపారం నేర్చుకోండి',
    startSubtitleLocal: 'ఆడుతూ వ్యాపారం నేర్చుకోండి',
    enterNameLabel: 'మీ పేరు చెప్పండి',
    namePlaceholder: 'మీ పేరు నమోదు చేయండి...',
    chooseStartupLabel: 'మీ స్టార్టప్ ఎంచుకోండి',
    customIdeaName: 'కస్టమ్ ఆలోచన',
    customIdeaLocal: 'మీ ఆలోచన',
    customPlaceholder: 'మీ స్టార్టప్ ఆలోచనను వివరించండి...',
    customSummaryPrefix: 'కస్టమ్ స్టార్టప్',
    startButton: 'ప్రారంభించండి',
    startFooter: 'పాచికలు వేయండి. మీ సామ్రాజ్యాన్ని నిర్మించండి. విజయవంతమైన వ్యాపారవేత్త అవ్వండి!',
    langToggle: 'భాష',
    signupTab: 'Sign Up',
    loginTab: 'Login',
    emailLabel: 'ఇమెయిల్ చిరునామా',
    passwordLabel: 'పాస్‌వర్డ్',
    passwordHint: 'కనీసం 6 అక్షరాలు',
    confirmPasswordLabel: 'పాస్‌వర్డ్ నిర్ధారించండి',
    passwordMismatch: 'పాస్‌వర్డ్‌లు సరిపోలలేదు',
    createAccountBtn: 'ఖాతా తెరవండి',
    loginBtn: 'లాగిన్ చేయండి',
    creatingAccount: 'ఖాతా తయారు చేస్తున్నాం...',
    loggingIn: 'లాగిన్ అవుతున్నాం...',
    emailPlaceholder: 'ఇమెయిల్ నమోదు చేయండి...',
    passwordPlaceholder: 'పాస్‌వర్డ్ సృష్టించండి...',
    confirmPlaceholder: 'మళ్ళీ నమోదు చేయండి...',
    loginPasswordPlaceholder: 'పాస్‌వర్డ్ నమోదు చేయండి...',
  },

  ta: {
    appTitle: 'உத்யோக்வர்ஸ்',
    turn: 'சுற்று',
    chooseAction: 'உங்கள் செயலை தேர்ந்தெடுக்கவும்',
    executed: 'முடிந்தது!',
    nextTurn: 'அடுத்த சுற்று',
    turnComplete: (turn, tile, stageName) =>
      `சுற்று ${turn} முடிந்தது! கட்டம் ${tile} | ${stageName} நிலை`,
    dashboard: 'டாஷ்போர்டு',
    funds: 'நிதி',
    customers: 'வாடிக்கையாளர்கள்',
    reputation: 'நற்பெயர்',
    burnRate: 'செலவு விகிதம்',
    ownership: 'உரிமை',
    stage: 'நிலை',
    customerTarget: 'வாடிக்கையாளர் இலக்கு',
    turnLog: 'சுற்று வரலாறு',
    low: 'குறைவு',
    medium: 'நடுத்தரம்',
    high: 'அதிகம்',
    bugMeter: 'பிழை மீட்டர்',
    stable: 'நிலையான',
    risky: 'ஆபத்தான',
    fragile: 'பலவீனமான',
    snakeChance: (pct) => `பாம்பு வாய்ப்பு: ${pct}%`,
    snakeLegend: 'பாம்பு',
    ladderLegend: 'ஏணி',
    youLegend: 'நீங்கள்',
    snakeTooltip: 'பாம்பு!',
    ladderTooltip: 'ஏணி!',
    goTo: 'செல்',
    climbTo: 'ஏறு',
    tileWord: 'கட்டம்',
    marketing: 'சந்தைப்படுத்தல்',
    product: 'தயாரிப்பு',
    team: 'அணி',
    bugfix: 'பிழை திருத்தம்',
    fundraise: 'நிதி திரட்டல்',
    save: 'சேமி',
    customersLabel: 'வாடிக்கையாளர்கள்',
    equityLabel: 'பங்கு',
    repPlus: 'நற்பெயர் +',
    repMinus: 'நற்பெயர் -',
    burnPlus: 'செலவு +',
    burnMinus: 'செலவு -',
    bugLabel: 'பிழை',
    rolling: 'உருட்டுகிறோம்...',
    rollDice: 'பகடை உருட்டு!',
    eventSnakeTitle: 'பாம்பு!',
    eventLadderTitle: 'ஏணி!',
    eventBugTitle: 'பிழை எச்சரிக்கை!',
    eventStageUpTitle: 'நிலை உயர்ந்தது!',
    eventWinTitle: 'வெற்றிகரமான தொழில்!',
    eventGameOverTitle: 'விளையாட்டு முடிந்தது',
    eventStruggleTitle: 'கஷ்ட காலம்',
    snakeFell: (from, to) => `கட்டம் ${from} இல் இருந்து ${to} க்கு விழுந்தீர்கள்!`,
    snakeEffectText: '(-5 வாடிக்கையாளர்கள், -ரூ.3,000)',
    ladderClimbed: (from, to) => `கட்டம் ${from} இல் இருந்து ${to} க்கு ஏறினீர்கள்!`,
    ladderEffectText: '(+10 வாடிக்கையாளர்கள்)',
    stageComplete: 'முடிந்தது! வரவேற்கிறோம்',
    rewardWord: 'பரிசு',
    currencyPrefix: 'ரூ.',
    winText: 'வாழ்த்துக்கள்! நீங்கள் வெற்றிகரமான தொழிலதிபர் ஆனீர்கள்!',
    winSubText: 'நீங்கள் வெற்றிகரமான தொழிலை கட்டமைத்தீர்கள்!',
    struggleText: 'நிதி குறைந்து வருகிறது! கவனமாக செல்லுங்கள்.',
    struggleSubText: 'மீட்பு இன்னும் சாத்தியம்!',
    loseText: 'தொழில் மூட வேண்டியதாயிற்று. ஆனால் விட்டுவிடாதீர்கள்!',
    loseSubText: 'ஒவ்வொரு தோல்வியும் ஒரு பாடம்.',
    acknowledgeWin: 'முடிவு பார்க்க',
    acknowledgeNext: 'முன்னே செல்',
    gameWonTitle: 'வெற்றிகரமான தொழில்!',
    gameLostTitle: 'விட மாட்டோம்!',
    gameWonSubtitle: 'வாழ்த்துக்கள்! வெற்றிகரமான தொழில் கட்டினீர்கள்!',
    gameLostSubtitle: 'பயணம் இங்கு நிற்கிறது, ஆனால் கற்றல் தொடர்கிறது.',
    stageReachedLabel: 'நிலை',
    turnsLabel: 'சுற்றுகள்',
    leaderboard: 'தரவரிசை',
    playAgain: 'மீண்டும் விளையாடு!',
    emptyLog: 'இன்னும் எந்த சுற்றும் நடக்கவில்லை... தொடங்குங்கள்!',
    startSubtitle: 'விளையாடி தொழில் கற்றுக்கொள்ளுங்கள்',
    startSubtitleLocal: 'விளையாடி தொழில் கற்றுக்கொள்ளுங்கள்',
    enterNameLabel: 'உங்கள் பெயர் சொல்லுங்கள்',
    namePlaceholder: 'உங்கள் பெயரை உள்ளிடுக...',
    chooseStartupLabel: 'உங்கள் ஸ்டார்ட்அப் தேர்வு',
    customIdeaName: 'சொந்த யோசனை',
    customIdeaLocal: 'உங்கள் யோசனை',
    customPlaceholder: 'உங்கள் ஸ்டார்ட்அப் யோசனை விவரிக்கவும்...',
    customSummaryPrefix: 'சொந்த ஸ்டார்ட்அப்',
    startButton: 'தொடங்குங்கள்',
    startFooter: 'பகடை உருட்டுங்கள். உங்கள் சாம்ராஜ்யத்தை கட்டுங்கள். வெற்றிகரமான தொழிலதிபர் ஆகுங்கள்!',
    langToggle: 'மொழி',
    signupTab: 'Sign Up',
    loginTab: 'Login',
    emailLabel: 'மின்னஞ்சல் முகவரி',
    passwordLabel: 'கடவுச்சொல்',
    passwordHint: 'குறைந்தது 6 எழுத்துகள்',
    confirmPasswordLabel: 'கடவுச்சொல் உறுதிப்படுத்தவும்',
    passwordMismatch: 'கடவுச்சொற்கள் பொருந்தவில்லை',
    createAccountBtn: 'கணக்கு திறக்கவும்',
    loginBtn: 'உள்நுழைக',
    creatingAccount: 'கணக்கு உருவாக்குகிறோம்...',
    loggingIn: 'உள்நுழைகிறோம்...',
    emailPlaceholder: 'மின்னஞ்சல் உள்ளிடவும்...',
    passwordPlaceholder: 'கடவுச்சொல் உருவாக்கவும்...',
    confirmPlaceholder: 'மீண்டும் உள்ளிடவும்...',
    loginPasswordPlaceholder: 'கடவுச்சொல் உள்ளிடவும்...',
  },

  mr: {
    appTitle: 'उद्योगव्हर्स',
    turn: 'डाव',
    chooseAction: 'तुमची कृती निवडा',
    executed: 'पूर्ण झाले!',
    nextTurn: 'पुढचा डाव',
    turnComplete: (turn, tile, stageName) =>
      `डाव ${turn} पूर्ण! घर ${tile} | ${stageName} टप्पा`,
    dashboard: 'डॅशबोर्ड',
    funds: 'भांडवल',
    customers: 'ग्राहक',
    reputation: 'प्रतिष्ठा',
    burnRate: 'खर्चाचा दर',
    ownership: 'मालकी',
    stage: 'टप्पा',
    customerTarget: 'ग्राहक लक्ष्य',
    turnLog: 'डावाचा इतिहास',
    low: 'कमी',
    medium: 'मध्यम',
    high: 'जास्त',
    bugMeter: 'समस्या मीटर',
    stable: 'स्थिर',
    risky: 'धोकादायक',
    fragile: 'नाजूक',
    snakeChance: (pct) => `सापाची संधी: ${pct}%`,
    snakeLegend: 'साप',
    ladderLegend: 'शिडी',
    youLegend: 'तुम्ही',
    snakeTooltip: 'साप!',
    ladderTooltip: 'शिडी!',
    goTo: 'जा',
    climbTo: 'चढ',
    tileWord: 'घर',
    marketing: 'विपणन',
    product: 'उत्पादन',
    team: 'संघ',
    bugfix: 'समस्या निवारण',
    fundraise: 'निधी उभारणी',
    save: 'बचत',
    customersLabel: 'ग्राहक',
    equityLabel: 'हिस्सा',
    repPlus: 'प्रतिष्ठा +',
    repMinus: 'प्रतिष्ठा -',
    burnPlus: 'खर्च +',
    burnMinus: 'खर्च -',
    bugLabel: 'समस्या',
    rolling: 'टाकत आहोत...',
    rollDice: 'फासा टाका!',
    eventSnakeTitle: 'साप!',
    eventLadderTitle: 'शिडी!',
    eventBugTitle: 'समस्या इशारा!',
    eventStageUpTitle: 'टप्पा वाढला!',
    eventWinTitle: 'यशस्वी उद्योग!',
    eventGameOverTitle: 'खेळ संपला',
    eventStruggleTitle: 'संघर्षाचा काळ',
    snakeFell: (from, to) => `घर ${from} वरून ${to} वर पडलात!`,
    snakeEffectText: '(-5 ग्राहक, -रु.3,000)',
    ladderClimbed: (from, to) => `घर ${from} वरून ${to} वर चढलात!`,
    ladderEffectText: '(+10 ग्राहक)',
    stageComplete: 'पूर्ण! स्वागत आहे',
    rewardWord: 'बक्षीस',
    currencyPrefix: 'रु.',
    winText: 'अभिनंदन! तुम्ही यशस्वी उद्योजक झालात!',
    winSubText: 'तुम्ही यशस्वी व्यवसाय उभारला!',
    struggleText: 'पैसे संपत आहेत! सावधानीने चला.',
    struggleSubText: 'पुनर्प्राप्ती अजूनही शक्य आहे!',
    loseText: 'व्यवसाय बंद करावा लागला. पण हार मानू नका!',
    loseSubText: 'प्रत्येक अपयश एक धडा आहे.',
    acknowledgeWin: 'निकाल पहा',
    acknowledgeNext: 'पुढे जा',
    gameWonTitle: 'यशस्वी उद्योग!',
    gameLostTitle: 'हार मानणार नाही!',
    gameWonSubtitle: 'अभिनंदन! यशस्वी व्यवसाय उभारलात!',
    gameLostSubtitle: 'प्रवास येथे संपतो, पण शिकणे सुरूच राहते.',
    stageReachedLabel: 'टप्पा',
    turnsLabel: 'डावे',
    leaderboard: 'लीडरबोर्ड',
    playAgain: 'पुन्हा खेळा!',
    emptyLog: 'अजून कोणताही डाव झाला नाही... सुरुवात करा!',
    startSubtitle: 'खेळत खेळत व्यवसाय शिका',
    startSubtitleLocal: 'खेळत खेळत व्यवसाय शिका',
    enterNameLabel: 'तुमचे नाव सांगा',
    namePlaceholder: 'नाव टाका...',
    chooseStartupLabel: 'तुमची स्टार्टअप निवडा',
    customIdeaName: 'स्वतःची कल्पना',
    customIdeaLocal: 'तुमची कल्पना',
    customPlaceholder: 'तुमच्या स्टार्टअपची कल्पना सांगा...',
    customSummaryPrefix: 'कस्टम स्टार्टअप',
    startButton: 'सुरुवात करा',
    startFooter: 'फासा टाका. तुमचे साम्राज्य उभारा. यशस्वी उद्योजक व्हा!',
    langToggle: 'भाषा',
    signupTab: 'Sign Up',
    loginTab: 'Login',
    emailLabel: 'ईमेल पत्ता',
    passwordLabel: 'पासवर्ड',
    passwordHint: 'किमान 6 अक्षरे',
    confirmPasswordLabel: 'पासवर्ड पुन्हा द्या',
    passwordMismatch: 'पासवर्ड जुळत नाहीत',
    createAccountBtn: 'खाते तयार करा',
    loginBtn: 'लॉगिन करा',
    creatingAccount: 'खाते तयार करत आहोत...',
    loggingIn: 'लॉगिन होत आहे...',
    emailPlaceholder: 'ईमेल टाका...',
    passwordPlaceholder: 'पासवर्ड तयार करा...',
    confirmPlaceholder: 'पुन्हा टाका...',
    loginPasswordPlaceholder: 'पासवर्ड टाका...',
  },
};
